import 'Lessons/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const BrowseCoursesDirective = angularDirectiveToReact('browseCourses', {});

export function BrowseCourses() {
    const [key] = useAngularToReactRoute();
    return <BrowseCoursesDirective key={key} />;
}
